/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { START_LESSON } from "./actionTypes"
import { startLessonError, startLessonSuccess } from "./actions"

//Include Both Helper File with needed methods
import { startLesson } from "../../../helpers/backend_helper"

function* start(action) {
  try {
    const response = yield call(startLesson, action.payload.form)
    if (response == undefined) {
      throw new Error("API error")
    }
    if (!response.success) {
      throw new Error("Error al guardar la lección")
    }
    yield put(startLessonSuccess(response))
  } catch (error) {
    yield put(startLessonError(error.message))
  }
}

function* lessonStartSaga() {
  yield takeEvery(START_LESSON, start)
}

export default lessonStartSaga
